import { PropertyContactType } from '../types/property';

export function getPropertyContactTypeName(type: PropertyContactType) {
    switch (type) {
        case PropertyContactType.PROPERTY_MANAGER:
            return 'Property Manager';
        case PropertyContactType.LANDLORD:
            return 'Landlord';
        case PropertyContactType.AGENCY_CONTACT:
            return 'Agency Contact';
        case PropertyContactType.OCCUPANT:
            return 'Occupant';
        default:
            return 'Unknown';
    }
}
